import scrollFunction from "./back-to-top";
import burgerNav from "./burger-menu";
import slider from "./slider";
import accordeon from "./accordeon";
import { addClass, removeClass } from "./functions";
import panel from "./panel";
import lazyLoad from "./lazy-load";

// Get tailwind responsive breakpoints
/** @type {object} */
const { screens } = require('tailwindcss/defaultTheme');


/** @type {HTMLElement} */
const body = <HTMLBodyElement>document.body;
const navBtnCheckBox = < HTMLInputElement >document.getElementById('nav-btn-checkBox');  
const navContainer = < HTMLDivElement >document.getElementById('nav-container');
const siteHeader = < HTMLElement >document.getElementById('site-header');
const toTheTop = < HTMLLinkElement >document.getElementById('to-the-top');
const contentTitle = < HTMLHeadingElement >document.getElementById('content-title');
const contentBody = < HTMLDivElement >document.getElementById('content-body');

// If page is trainers page
const homePage = body.classList.contains('home');
// If page is trainers page
const trainersPage = body.classList.contains('trainers');
// If page is product page
const productPage = body.classList.contains('woocommerce-page');
// If archive page
const archivePage = body.classList.contains('post-type-archive');
// If cart page
const cartPage = body.classList.contains('woocommerce-cart');
// If page is catalogue
const catalogPage = body.classList.contains('catalog');

let mediaQueryScreenLg: any = window.matchMedia(`(max-width: ${screens.lg})`);
let mediaQueryScreenMd: any = window.matchMedia(`(max-width: ${screens.md})`);
let mediaQueryScreenSm: any = window.matchMedia(`(max-width: ${screens.sm})`);

/**
 * Burger menu Btn call to action
 */
let toggleNav = new burgerNav(navBtnCheckBox, navContainer, mediaQueryScreenLg);
// Activate call to action on load
// if(mediaQueryScreenLg.matches){ 
  toggleNav.init();
// }
// On window resize update
// window.addEventListener('resize', (e: Event) => {
//   mediaQueryScreenLg.matches ? toggleNav.init() : toggleNav.resize();
// });

/**
 * Back to top init
 */
let backToTop = new scrollFunction(toTheTop);
backToTop.evenListner();

let last_scroll_top: number = 0;

/**
 * OnScroll
 */
window.onscroll = () => {
  backToTop.handleClass();
  let scroll_top = window.scrollY;

  let elOffsetTop = contentBody.offsetTop;
  let headerHeight = siteHeader.offsetHeight;
  let elDistance = elOffsetTop - scroll_top - headerHeight;

  // Translate title on scroll
  if(contentTitle){
  
    const checkpoint = 300;
    let opacity;
    
    if (scroll_top <= checkpoint) {
      opacity = 1 - scroll_top / checkpoint;
    } else {
      opacity = 0;
    }

    contentTitle.parentElement.parentElement.style.opacity = opacity;

    if(elDistance > headerHeight){
      contentTitle.style.transform = 'translateY(' + -scroll_top/2 + 'px)';
    }
  }
  // Header sticky behavior on scroll
  if(siteHeader){
    
    if(elDistance < headerHeight){
      if( scroll_top < last_scroll_top) {
        removeClass( {domElement: siteHeader, classList: 'scrolled-down'} )
        addClass( {domElement: siteHeader, classList: 'scrolled-up'} )
      }
      else {
        removeClass( {domElement: siteHeader, classList: 'scrolled-up'} )
        addClass( {domElement: siteHeader, classList: 'scrolled-down'} )
      }
      last_scroll_top = scroll_top;
    }
  }
}

/**
 * Taximonials slider (Home page)
 */
if(homePage || (productPage && !archivePage)){
  const testimonials = < HTMLDivElement >document.getElementById('customer-testimonials-list');
  if(testimonials !== null){
    const testimonialsList = < HTMLUListElement>testimonials.querySelector('.decent-comments > ul');
    let testimonialsSlider = new slider(testimonialsList);
    testimonialsSlider.init();
  }
}

/**
 * Trainers slider
 */
if(trainersPage){
  const trainersList = < HTMLDivElement >document.getElementById('trainers-columns');
  if(trainersList !== null){
    let trainers = new slider(trainersList, mediaQueryScreenMd);
    trainers.init();
  }
} 
/**
 * Products accordeon
 */
if(productPage && !archivePage && !cartPage){
  const objProgList = < HTMLUListElement >document.getElementById('product-obj-prog');
  if(objProgList !== null){
    let objProgAccordeon = new accordeon(objProgList, mediaQueryScreenSm);
    objProgAccordeon.init();  
  }
}

/**
 * Mobile catalogue filter panel
 */
if(catalogPage){
  const applyFilterContent = < HTMLDivElement >document.getElementById('catalog-product-filters-content');
  if(applyFilterContent !== null){
    const applyFilterBtn = < HTMLButtonElement >applyFilterContent.querySelector('button.awf-apply-filter-btn')
    const filtersPanelTrigger = < HTMLDivElement >document.getElementById('catalog-product-filters-title');
    let filtersPanel = new panel(filtersPanelTrigger, applyFilterBtn, mediaQueryScreenMd);
    filtersPanel.init();  
  }
}

//Prefetch all the images
let lazyImages = document.querySelectorAll('.lazy-image');

if(lazyImages.length > 0){
  let runLazyLoad = new lazyLoad(lazyImages, 50);
  runLazyLoad.init();
}

